import { CreateOrganizationDto, OrganizationDto, UpdateOrganizationDto } from "@dialogics/shared/dto/types"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { ModalProps } from "../../component/modal"
import { useCreateOrganizationMutation, useUpdateOrganizationMutation } from "./organization-service"

type OrganizationFormProps = {
  organization?: OrganizationDto
} & ModalProps

export const OrganizationForm = ({ isOpen, onClose, organization }: OrganizationFormProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<CreateOrganizationDto | UpdateOrganizationDto>({
    defaultValues: organization,
  })
  const [createOrganization, { isLoading: isCreating }] = useCreateOrganizationMutation()
  const [updateOrganization, { isLoading: isUpdating }] = useUpdateOrganizationMutation()

  useEffect(() => {
    if (organization) {
      reset(organization)
    } else {
      reset({ name: "", title: "", description: "" })
    }
  }, [organization, reset])

  const onSubmit = async (data: CreateOrganizationDto | UpdateOrganizationDto) => {
    if (organization) {
      await updateOrganization({ id: organization.id, ...data })
    } else {
      await createOrganization(data as CreateOrganizationDto)
    }
    onClose()
  }

  return (
    <dialog className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">{organization ? "Редактировать организацию" : "Создать организацию"}</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <fieldset className="fieldset">
            <legend className="fieldset-legend">Название</legend>
            <input
              {...register("name", {
                required: "Название обязательно",
                pattern: { value: /^[a-z]+$/, message: "Только строчные латинские символы" },
              })}
              className={`input input-bordered w-full ${errors.name ? "input-error" : ""}`}
            />
            {errors.name && <span className="text-error text-xs">{errors.name.message}</span>}
          </fieldset>
          <fieldset className="fieldset">
            <legend className="fieldset-legend">Заголовок</legend>
            <input
              {...register("title", { required: "Заголовок обязателен" })}
              className={`input input-bordered w-full ${errors.title ? "input-error" : ""}`}
            />
            {errors.title && <span className="text-error text-xs">{errors.title.message}</span>}
          </fieldset>
          <fieldset className="fieldset">
            <legend className="fieldset-legend">Описание</legend>
            <textarea {...register("description")} className="textarea textarea-bordered w-full" />
          </fieldset>
          <div className="modal-action">
            <button type="button" className="btn" onClick={onClose} disabled={isCreating || isUpdating}>
              Отмена
            </button>
            <button type="submit" className="btn btn-primary" disabled={isCreating || isUpdating}>
              {isCreating || isUpdating ? "Сохранение..." : "Сохранить"}
            </button>
          </div>
        </form>
      </div>
    </dialog>
  )
}
